<template>
	<div class="navbar">
		
		<div class="w-100 h-100 flex-space-between">
			<div class="home-container boxSizing flex-box">
				<div class="home-wrapper">
					<router-link to="/">
						<img src="@/assets/home.png" class="home-icon">
					</router-link>
				</div>
				<p class="username">欢迎您,{{userInfo.nickName?userInfo.nickName:""}}</p>
			</div>
			
			
			<div class="right-menu flex-box">
				<div class="add-view pointer" @click="goToContractCalendar">
					<el-button type="primary" round class="bg-index mr-40">工作日程</el-button>
				</div>
				<div class="time-container">
					<span class="time-title">{{deteInfo.time}}</span>
					<span class="data-title">{{deteInfo.day}} {{deteInfo.week}}</span>
				</div>
				<div class="message-wrapper mr-20 pointer" @click="toggleMessageDialog">
					<el-badge :value="msgNum" class="item" :hidden="msgNum==0">
						<img src="@/assets/msg.png" class="user-avatar">
					</el-badge>
				</div>
				<el-dropdown class="avatar-container">
					<div class="avatar-wrapper">
						<img :src="userInfo.avatar?userInfo.avatar:require('@/assets/user.png')" class="user-avatar">
					</div>
					<el-dropdown-menu slot="dropdown" class="user-dropdown">
						<router-link to="/">
							<el-dropdown-item>
								首页
							</el-dropdown-item>
						</router-link>
						<el-dropdown-item>
							<div class="flex-column py-10 boxSizing w-100" @click.stop="isSetting=!isSetting">
								<div class="flex-box w-100">
									<div class="item-title-view">
										<div class="item-text2 pointer" id="set">设置</div>
									</div>
								</div>
								<div v-show="isSetting" class="set_box w-100 mt-10 boxSizing">
									<div class="py-10  boxSizing fontColor-999 pointer borderBottmon"
										@click.stop="showSetPass=true;">修改密码</div>
									<div class="py-10 boxSizing fontColor-999 pointer"
										@click="open=true;userDialog=false;">
										修改头像
									</div>
								</div>
							</div>
						</el-dropdown-item>
						<el-dropdown-item divided @click.native="showMajor=true">
							<span style="display:block;">修改专业</span>
						</el-dropdown-item>
						<el-dropdown-item divided @click.native="showMessage=true">
							<span style="display:block;">客户留言</span>
						</el-dropdown-item>
						<el-dropdown-item divided @click.native="logout">
							<span style="display:block;">退出登录</span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		
		<!-- 消息通知 -->
		<div class="message-dialog boxShadow" v-if="messageDialog">
			<div class="message-container">
				<div class="message-title flex-space-between px-30 boxSizing">
					<span>消息
						<span style="font-size: 13px;cursor: pointer;color: #fff;"
							@click="allReadNotice()">全部标记已读</span>
					</span>
					<i class="el-icon-close fontWeight font20 pointer" @click="closeMessageDialog"></i>
				</div>
				<div
					class="message-scroll-container"
					ref="messageScrollContainer"
					@scroll="handleMessageScroll"
				>
					<div class="item-view" v-for="(item,index) in messageList" :key="index"
						@click.stop="onMsgData(item)">
						<div class="item-icon-view">
							<el-image class="msg-icon" :src="require('@/icons/svg/msg.svg')"></el-image>
						</div>
						<div class="item-data">
							<div class="item-msg-title">{{item.title}}</div>
							<div class="item-msg-text mt-15">{{item.message}}</div>
							<div class="del-title mt-15">{{item.createTime}}</div>
						</div>
						<div class="del-view">
							<el-image class="del-icon" v-if="item.status=='1'" @click.stop="delNotice(item)"
								:src="require('@/icons/svg/del.svg')"></el-image>
							<span v-else>未读</span>
						</div>
					</div>
					<!-- 加载状态提示 -->
					<div class="loading-more" v-if="messageLoading">
						<i class="el-icon-loading"></i>
						<span>加载中...</span>
					</div>
					<!-- 没有更多数据提示 -->
					<div class="no-more-data" v-if="!messageLoading && noMoreMessage && messageList.length > 0">
						<span>— 没有更多消息了 —</span>
					</div>
					<!-- 空数据提示 -->
					<div class="empty-message" v-if="!messageLoading && messageList.length === 0">
						<i class="el-icon-message"></i>
						<span>暂无消息</span>
					</div>
				</div>
			</div>
		</div>
		

		<el-dialog title="修改专业" :close-on-click-modal="false" :visible.sync="showMajor" width="800px" class="major-dialog" @open="handleMajorDialogOpen">
			<!-- Tab 切换 -->
			<div class="major-tabs">
				<el-radio-group v-model="majorActiveTab" size="medium">
					<el-radio-button label="lawsuit">诉讼专业</el-radio-button>
					<el-radio-button label="nonLawsuit">非诉讼专业</el-radio-button>
				</el-radio-group>
			</div>
			
			<!-- 诉讼专业（案由） -->
			<div class="major-content-new" v-show="majorActiveTab === 'lawsuit'">
				<div class="tree-select-container">
					<div class="tree-header">
						<span class="tree-title">选择诉讼专业</span>
						<el-input
							v-model="lawsuitFilterText"
							placeholder="输入关键词筛选"
							prefix-icon="el-icon-search"
							size="small"
							clearable
							class="tree-filter-input"
						></el-input>
					</div>
					<div class="tree-wrapper">
						<el-tree
							ref="lawsuitTree"
							:data="lawsuitMajorList"
							:props="treeProps"
							show-checkbox
							node-key="id"
							:default-checked-keys="selectedLawsuitIds"
							:filter-node-method="filterNode"
							:default-expand-all="false"
							@check="handleLawsuitCheck"
							class="major-tree"
						>
						</el-tree>
					</div>
				</div>
				<!-- 已选择的诉讼专业标签 -->
				<div class="selected-tags-container">
					<div class="selected-tags-header">
						<span class="selected-title">已选择：</span>
						<span class="selected-count">{{ selectedLawsuitItems.length }} 项</span>
						<el-button
							v-if="selectedLawsuitItems.length > 0"
							type="text"
							size="mini"
							@click="clearAllLawsuit"
							class="clear-all-btn"
						>清空全部</el-button>
					</div>
					<div class="selected-tags-wrapper" v-if="selectedLawsuitItems.length > 0">
						<el-tag
							v-for="item in selectedLawsuitItems"
							:key="item.id"
							closable
							size="medium"
							type="info"
							@close="removeLawsuitTag(item)"
							class="selected-tag"
						>
							{{ item.fullPath || item.label }}
						</el-tag>
					</div>
					<div class="empty-selected" v-else>
						<span>暂未选择任何诉讼专业</span>
					</div>
				</div>
			</div>
			
			<!-- 非诉讼专业 -->
			<div class="major-content-new" v-show="majorActiveTab === 'nonLawsuit'">
				<div class="tree-select-container">
					<div class="tree-header">
						<span class="tree-title">选择非诉讼专业</span>
						<el-input
							v-model="nonLawsuitFilterText"
							placeholder="输入关键词筛选"
							prefix-icon="el-icon-search"
							size="small"
							clearable
							class="tree-filter-input"
						></el-input>
					</div>
					<div class="tree-wrapper">
						<el-tree
							ref="nonLawsuitTree"
							:data="majorList"
							:props="treeProps"
							show-checkbox
							node-key="id"
							:default-checked-keys="selectedNonLawsuitIds"
							:filter-node-method="filterNode"
							:default-expand-all="false"
							@check="handleNonLawsuitCheck"
							class="major-tree"
						>
						</el-tree>
					</div>
				</div>
				<!-- 已选择的非诉讼专业标签 -->
				<div class="selected-tags-container">
					<div class="selected-tags-header">
						<span class="selected-title">已选择：</span>
						<span class="selected-count">{{ selectedNonLawsuitItems.length }} 项</span>
						<el-button
							v-if="selectedNonLawsuitItems.length > 0"
							type="text"
							size="mini"
							@click="clearAllNonLawsuit"
							class="clear-all-btn"
						>清空全部</el-button>
					</div>
					<div class="selected-tags-wrapper" v-if="selectedNonLawsuitItems.length > 0">
						<el-tag
							v-for="item in selectedNonLawsuitItems"
							:key="item.id"
							closable
							size="medium"
							type="info"
							@close="removeNonLawsuitTag(item)"
							class="selected-tag"
						>
							{{ item.fullPath || item.label }}
						</el-tag>
					</div>
					<div class="empty-selected" v-else>
						<span>暂未选择任何非诉讼专业</span>
					</div>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="showMajor = false">取 消</el-button>
				<el-button type="primary" @click="confirmCheck">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改密码" :close-on-click-modal="false" :visible.sync="showSetPass" width="30%">
			<div>
				<el-form :model="passForm" :rules="rules" ref="passForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="旧密码" prop="oldPassword">
						<el-input v-model="passForm.oldPassword" type="password"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="newPassword">
						<el-input v-model="passForm.newPassword" type="password"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="confirmPassword">
						<el-input v-model="passForm.confirmPassword" type="password"
							@change="equalToPassword"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showSetPass = false">取 消</el-button>
				<el-button type="primary" @click="setPassSubmit">确 定</el-button>
			</span>
		</el-dialog>



		<el-dialog title="客户留言" top="5vh" :visible.sync="showMessage" width="75%" @open="getMessage(1)">
			<div class="w-100">
				<el-table :data="leaveMessage" style="width: 100%" height="450"
					:header-cell-style="{'text-align':'center','background':'#f2f2f2','border':'none'}"
					:cell-style="{'text-align':'center','font-size':'16px','height':'40px'}">
					<el-table-column  prop="userName" label="名称或字号" width="250">
					</el-table-column>
					<el-table-column prop="question" label="留言内容" width="">
						<template slot-scope="scope">
							<div  :title="scope.row.question">
								{{scope.row.question}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="createTime" label="提交时间" width="">
					</el-table-column>
					<el-table-column prop="reply" label="回复内容" width="">
						</el-table-column>
						<el-table-column prop="replyTime" label="回复时间" width="">
						</el-table-column>
						<el-table-column prop="status" label="状态" width="120">
							<template slot-scope="scope">
								<!-- 0提交、1已回复、2已完成 -->
								<span :style="{'color':scope.row.status=='2'?'#00aa7f':''}"
									class=" pointer ml-20">{{scope.row.status=='0'?'已提交':scope.row.status=='1'?'已回复':'已完成'}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="zip" label="操作" width="200">
							<template slot-scope="scope">
								<span class="fontColor-index pointer ml-20" @click="reply(scope.row)"
									v-if="scope.row.status == '0'">回复</span>
							</template>
						</el-table-column>
				</el-table>

				<div class="flex-center mt-20">
					<pagination :current="messageParams.pageNum" :total="messageTotal" @change="getMessage">
					</pagination>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="回复留言" :visible.sync="replyShow" width="40%">
			<div class="w-100">
				<el-input type="textarea" :rows="8" placeholder="请填写您要留言的内容" v-model="replyInfo.reply">
				</el-input>

				<div slot="footer" class="dialog-footer mt-20">
					<el-button @click="replyShow = false" style="margin-right: 30px;">取 消</el-button>
					<el-button type="primary" @click="replySumbit">确 定</el-button>
				</div>
			</div>
		</el-dialog>

		<el-dialog :title="title" :visible.sync="open" width="800px" append-to-body @opened="modalOpened"
			@close="closeDialog">
			<el-row>
				<el-col :xs="24" :md="12" :style="{height: '350px'}">
					<vue-cropper ref="cropper" :img="options.img" :info="true" :autoCrop="options.autoCrop"
						:autoCropWidth="options.autoCropWidth" :autoCropHeight="options.autoCropHeight"
						:fixedBox="options.fixedBox" :outputType="options.outputType" @realTime="realTime"
						v-if="visible" />
				</el-col>
				<el-col :xs="24" :md="12" :style="{height: '350px'}">
					<div class="avatar-upload-preview">
						<img :src="previews.url" :style="previews.img" />
					</div>
				</el-col>
			</el-row>
			<br />
			<el-row>
				<el-col :lg="2" :sm="3" :xs="3">
					<el-upload action="#" :http-request="requestUpload" :show-file-list="false"
						:before-upload="beforeUpload">
						<el-button size="small">
							选择
							<i class="el-icon-upload el-icon--right"></i>
						</el-button>
					</el-upload>
				</el-col>
				<el-col :lg="{span: 1, offset: 2}" :sm="2" :xs="2">
					<el-button icon="el-icon-plus" size="small" @click="changeScale(1)"></el-button>
				</el-col>
				<el-col :lg="{span: 1, offset: 1}" :sm="2" :xs="2">
					<el-button icon="el-icon-minus" size="small" @click="changeScale(-1)"></el-button>
				</el-col>
				<el-col :lg="{span: 1, offset: 1}" :sm="2" :xs="2">
					<el-button icon="el-icon-refresh-left" size="small" @click="rotateLeft()"></el-button>
				</el-col>
				<el-col :lg="{span: 1, offset: 1}" :sm="2" :xs="2">
					<el-button icon="el-icon-refresh-right" size="small" @click="rotateRight()"></el-button>
				</el-col>
				<el-col :lg="{span: 2, offset: 6}" :sm="2" :xs="2">
					<el-button type="primary" size="small" @click="uploadImg()">提 交</el-button>
				</el-col>
			</el-row>
		</el-dialog>
		<audio style="display: none;" src="https://www.qiandau.com/mp3/01.mp3"  ref="audioPlayer"></audio>
		
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		removeToken
	} from '@/utils/auth'
	import {
		getUserInfo,
		uploadAvatar,
		updateUserPwd,
		getCurrentUser,
		updateUser,
		treeselect as majorTreeSelect,
		leaveMessageList,
		leaveMessageEdit,
		updateMajor
	} from "@/api/user"
	import {
		noticeList,
		readAllNotice,
		readNotice,
		removeNotice
	} from "@/api/index"
	import {
		getBriefListAll
	} from "@/api/claims.js"
	import {
		VueCropper
	} from "vue-cropper";
	import {
		debounce
	} from '@/utils'
	/* 树形穿梭框 */
	import treeTransfer from "@/components/treeTransfer/index";
	export default {
		components: {
			VueCropper,
			treeTransfer
		},
		data() {
			return {
				msgNum: 0,
				deteInfo: {
					time: "",
					day: "",
					week: "",
				},
				userName: "",
				time: null, //定时器
				messageDialog: false,
				isMessage: false,
				isSetting: false, //是否显示设置
				showSetPass: false, //显示修改密码弹框
				userInfo: {}, //用户信息
				passForm: {
					oldPassword: "",
					newPassword: "",
					confirmPassword: ""
				},
				rules: {
					oldPassword: [{
						required: true,
						message: '旧密码不能为空',
						trigger: 'blur'
					}],
					newPassword: [{
							required: true,
							message: '新密码不能为空',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					confirmPassword: [{
						required: true,
						message: '确认密码不能为空',
						trigger: 'blur'
					}],
				},
				// 是否显示cropper
				visible: false,
				// 弹出层标题
				title: "修改头像",
				previews: {},
				resizeHandler: null,
				// 是否显示弹出层
				open: false,
				options: {
					img: require('@/assets/user.png'), // 裁剪图片的地址
					autoCrop: true, // 是否默认生成截图框
					autoCropWidth: 200, // 默认生成截图框宽度
					autoCropHeight: 200, // 默认生成截图框高度
					fixedBox: true, // 固定截图框大小 不允许改变
					outputType: "png" // 默认生成截图为PNG格式
				},
				majorList: [], //非诉讼专业
				lawsuitMajorList: [], //诉讼专业（案由）
				treeProps: {
					label: 'label',
					children: 'children'
				},
				showMajor: false, //专业显隐弹框
				majorInfo: '', //已选择的专业
				majorActiveTab: 'lawsuit', //当前选中的tab: lawsuit-诉讼专业, nonLawsuit-非诉讼专业
				userUpdateInfo: { //修改用户信息
					majorId: [],
					major: [],
					litigationTypeId: [], //诉讼专业ID
					litigationTypeName: [], //诉讼专业名称
					userId: "",
					userName: ""
				},
				userMajor: "", //用户专业
				checkedKeys: [], //默认回显专业
				litigationCheckedKeys: [], //默认回显诉讼专业
				
				// 新增：树形选择相关
				lawsuitFilterText: '', // 诉讼专业筛选文本
				nonLawsuitFilterText: '', // 非诉讼专业筛选文本
				selectedLawsuitIds: [], // 已选择的诉讼专业ID
				selectedLawsuitItems: [], // 已选择的诉讼专业项（包含完整路径）
				selectedNonLawsuitIds: [], // 已选择的非诉讼专业ID
				selectedNonLawsuitItems: [], // 已选择的非诉讼专业项（包含完整路径）

				showMessage: false, //留言显隐
				messageParams: { //参数
					type: 1,
					pageSize: 10,
					pageNum: 1
				},
				total: 0,

				replyShow: false,
				replyInfo: {},
				replyData: {}, //回复参数
				messageTotal: 0,
				leaveMessage: [], //留言列表
				audios: null, //铃声
				filterMethod(query, item) {
					return item.label.indexOf(query) > -1;
				},
				toList: [], //右边非诉讼专业
				lawsuitToList: [], //右边诉讼专业
				defaultCheckedKeys: [], //默认选中的节点
				showAudio:false,//是否显示播放
				messageList:[],
				noticePageNum: 1, // 通知消息当前页码
				messageLoading: false, // 消息加载状态
				noMoreMessage: false, // 是否没有更多消息
				messagePageSize: 10, // 每页消息数量
				
				// 补充解答相关
				supplementListShow: false, // 补充解答列表弹窗
				supplementList: [], // 补充解答列表
				currentAdvice: {} // 当前选中的咨询记录
			}
		},
		watch: {
			"$socketPublic.state.msg": {
				immediate: true,
				deep: true,
				handler(newVal, oldVal) {
					console.log("监听socket的消息-------------", newVal);
					if (newVal && newVal.data) {
						this.getNoticeList(1,false);
						// if (JSON.parse(newVal.data).type == 'message') {
							this.playMessageAudio();
						// }
					}else{
						this.showAudio = false;
					}
				}
			},
			// 监听诉讼专业筛选文本变化
			lawsuitFilterText(val) {
				this.$refs.lawsuitTree && this.$refs.lawsuitTree.filter(val);
			},
			// 监听非诉讼专业筛选文本变化
			nonLawsuitFilterText(val) {
				this.$refs.nonLawsuitTree && this.$refs.nonLawsuitTree.filter(val);
			}
		},
		computed: {
			...mapGetters([
				'avatar'
			])
		},
		beforeDestroy() {
			this.time = null;
			clearInterval(this.time);
		},
		mounted() {
			this.showAudio = false;
			this.getTime();
			this.getNoticeList(1,true);
			this.getMajorTreeselect();
			this.getUserInfoFun();
			this.getBriefFuns()
			this.time = setInterval(() => {
				this.getTime()
			}, 1000);
		},
		methods: {
			//获取诉讼专业（案由列表）
			getBriefFuns(initSelected = false){
				return getBriefListAll().then(res=>{
					if(res.data) {
						// 转换数据格式为树形结构
						this.lawsuitMajorList = this.formatBriefToTree(res.data);
						// 如果需要初始化选中状态
						if(initSelected) {
							this.initLawsuitSelectedItems();
						}
					}
				})
			},
			// 将案由数据转换为树形结构
			formatBriefToTree(data) {
				if(!data || !Array.isArray(data)) return [];
				return data.map(item => {
					const node = {
						id: item.id,
						label: item.briefName || item.name || item.label,
						parentId: item.parentId || 0
					};
					if(item.children && item.children.length > 0) {
						node.children = this.formatBriefToTree(item.children);
					}
					return node;
				});
			},
			// 弹窗打开时的处理
			handleMajorDialogOpen() {
				// 重新加载非诉讼专业数据
				this.getMajorTreeselect().then(() => {
					this.initNonLawsuitSelectedItems();
				});
				// 重新加载诉讼专业数据，并在加载完成后初始化选中状态
				this.getBriefFuns(true);
			},
			// 初始化诉讼专业已选择数据
			initLawsuitSelectedItems() {
				// 初始化诉讼专业
				this.selectedLawsuitIds = [...this.userUpdateInfo.litigationTypeId];
				this.selectedLawsuitItems = this.buildSelectedItems(
					this.lawsuitMajorList,
					this.selectedLawsuitIds
				);
				
				// 等待DOM更新后设置树的选中状态
				this.$nextTick(() => {
					if (this.$refs.lawsuitTree) {
						this.$refs.lawsuitTree.setCheckedKeys(this.selectedLawsuitIds);
					}
				});
			},
			// 初始化非诉讼专业已选择数据
			initNonLawsuitSelectedItems() {
				// 初始化非诉讼专业
				this.selectedNonLawsuitIds = [...this.userUpdateInfo.majorId];
				this.selectedNonLawsuitItems = this.buildSelectedItems(
					this.majorList,
					this.selectedNonLawsuitIds
				);
				
				// 等待DOM更新后设置树的选中状态
				this.$nextTick(() => {
					if (this.$refs.nonLawsuitTree) {
						this.$refs.nonLawsuitTree.setCheckedKeys(this.selectedNonLawsuitIds);
					}
				});
			},
			// 根据选中的ID构建已选择项（包含完整路径）
			buildSelectedItems(treeData, selectedIds) {
				const items = [];
				const findNodeWithPath = (nodes, path = []) => {
					for (const node of nodes) {
						const currentPath = [...path, node.label];
						if (selectedIds.includes(node.id)) {
							items.push({
								id: node.id,
								label: node.label,
								fullPath: currentPath.join('-')
							});
						}
						if (node.children && node.children.length > 0) {
							findNodeWithPath(node.children, currentPath);
						}
					}
				};
				findNodeWithPath(treeData);
				return items;
			},
			// 树节点筛选方法
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			// 处理诉讼专业选中变化
			handleLawsuitCheck(node, checkedInfo) {
				// 获取所有选中的叶子节点（不包含半选的父节点）
				const checkedKeys = checkedInfo.checkedKeys;
				this.selectedLawsuitIds = checkedKeys;
				this.selectedLawsuitItems = this.buildSelectedItems(
					this.lawsuitMajorList,
					checkedKeys
				);
			},
			// 处理非诉讼专业选中变化
			handleNonLawsuitCheck(node, checkedInfo) {
				const checkedKeys = checkedInfo.checkedKeys;
				this.selectedNonLawsuitIds = checkedKeys;
				this.selectedNonLawsuitItems = this.buildSelectedItems(
					this.majorList,
					checkedKeys
				);
			},
			// 移除诉讼专业标签
			removeLawsuitTag(item) {
				const index = this.selectedLawsuitIds.indexOf(item.id);
				if (index > -1) {
					this.selectedLawsuitIds.splice(index, 1);
					this.selectedLawsuitItems = this.selectedLawsuitItems.filter(i => i.id !== item.id);
					// 同步更新树的选中状态
					this.$nextTick(() => {
						if (this.$refs.lawsuitTree) {
							this.$refs.lawsuitTree.setCheckedKeys(this.selectedLawsuitIds);
						}
					});
				}
			},
			// 移除非诉讼专业标签
			removeNonLawsuitTag(item) {
				const index = this.selectedNonLawsuitIds.indexOf(item.id);
				if (index > -1) {
					this.selectedNonLawsuitIds.splice(index, 1);
					this.selectedNonLawsuitItems = this.selectedNonLawsuitItems.filter(i => i.id !== item.id);
					// 同步更新树的选中状态
					this.$nextTick(() => {
						if (this.$refs.nonLawsuitTree) {
							this.$refs.nonLawsuitTree.setCheckedKeys(this.selectedNonLawsuitIds);
						}
					});
				}
			},
			// 清空所有诉讼专业
			clearAllLawsuit() {
				this.selectedLawsuitIds = [];
				this.selectedLawsuitItems = [];
				this.$nextTick(() => {
					if (this.$refs.lawsuitTree) {
						this.$refs.lawsuitTree.setCheckedKeys([]);
					}
				});
			},
			// 清空所有非诉讼专业
			clearAllNonLawsuit() {
				this.selectedNonLawsuitIds = [];
				this.selectedNonLawsuitItems = [];
				this.$nextTick(() => {
					if (this.$refs.nonLawsuitTree) {
						this.$refs.nonLawsuitTree.setCheckedKeys([]);
					}
				});
			},
			// 跳转到合同日历页面
			goToContractCalendar() {
				this.$router.push('/contract-calendar');
			},
			// 切换消息弹窗显示
			toggleMessageDialog() {
				this.messageDialog = !this.messageDialog;
				if (this.messageDialog) {
					// 打开弹窗时重新加载第一页数据
					this.noticePageNum = 1;
					this.noMoreMessage = false;
					this.messageList = [];
					this.getNoticeList(1, false);
				}
			},
			// 关闭消息弹窗
			closeMessageDialog() {
				this.messageDialog = false;
				// 重置分页状态
				this.noticePageNum = 1;
				this.messageList = [];
				this.noMoreMessage = false;
			},
			// 监听滚动加载更多
			handleMessageScroll(e) {
				const container = e.target;
				const scrollTop = container.scrollTop;
				const scrollHeight = container.scrollHeight;
				const clientHeight = container.clientHeight;
				
				// 当滚动到底部时加载更多（距离底部20px时触发）
				if (scrollTop + clientHeight >= scrollHeight - 20) {
					this.loadMoreMessages();
				}
			},
			// 加载更多消息
			loadMoreMessages() {
				// 如果正在加载或没有更多数据，则不执行
				if (this.messageLoading || this.noMoreMessage) {
					return;
				}
				this.noticePageNum++;
				this.getNoticeList(this.noticePageNum, false, true);
			},
			/* 播放消息提示 */
			playMessageAudio() {
				// this.showAudio = true;
				const audioPlayer = this.$refs.audioPlayer;
				setTimeout(()=> {
					// audioPlayer.currentTime = 0; // 重置播放进度为0
					if (audioPlayer) {
						audioPlayer.load(); // 重新加载音频
						audioPlayer.play()
					}
				}, 500);
			},
			onMsgData(item) {
				item.status = 1;
				readNotice({
					id: item.id,
					status: 1
				}).then(res => {
					this.getNoticeList(1,false);
					if (item.orthType == 'message') {
						this.messageDialog = false;
						this.showMessage = true
					}
				})
			},
			delNotice(item) {
				removeNotice([item.id]).then(res => {
					this.getNoticeList(1,false);
					this.getMessage(1)
					this.$message.success("删除成功");
				})
			},
			allReadNotice() { //标记全部为已读
				readAllNotice().then(res => {
					this.getNoticeList(1,false);
				})
			},
			replySumbit() {
				if(!this.replyInfo.reply){
					return this.$message.error("留言不能为空");
				}
				this.replyInfo.lawyerRead = '1';
				this.replyInfo.status = '1';
				leaveMessageEdit(this.replyInfo).then(() => {
					this.$message.success("已回复");
					this.replyShow = false;
					this.getMessage(1)
				})
			},
			/* 回复信息 */
			reply(item) {
				if (item.status == '1' || item.status == '2') {
					this.$message.success("已完成或已回复");
					return
				}
				this.replyInfo = item;
				this.replyShow = true;
			},
			/* 获取用户留言列表 */
			getMessage(e) {
				if (e) {
					this.messageParams.pageNum = e;
				}
				leaveMessageList(this.messageParams).then((res) => {
					this.leaveMessage = res.rows;
					this.messageTotal = res.total;

				})
			},
			
			/* ========== 补充解答相关方法 ========== */
			
			/**
			 * 查看补充解答列表
			 * @param {Object} row - 当前咨询记录
			 */
			viewSupplements(row) {
				this.currentAdvice = row;
				this.supplementListShow = true;
				this.getSupplementList(row.id);
			},
			
			/**
			 * 获取补充解答列表
			 * @param {Long} adviceId - 法律咨询ID
			 */
			getSupplementList(adviceId) {
				getSupplementByAdviceId(adviceId).then(res => {
					this.supplementList = res.data || [];
				}).catch(err => {
					console.error('获取补充解答列表失败:', err);
					this.supplementList = [];
				});
			},
			
			/* 确定专业 */
			confirmCheck() {
				// 从已选择的项中提取ID和名称
				const lawsuitIds = this.selectedLawsuitItems.map(item => item.id);
				const lawsuitNames = this.selectedLawsuitItems.map(item => item.label);
				const nonLawsuitIds = this.selectedNonLawsuitItems.map(item => item.id);
				const nonLawsuitNames = this.selectedNonLawsuitItems.map(item => item.label);
				
				let objs = {
					// 非诉讼专业
					majorId: JSON.stringify(nonLawsuitIds),
					major: nonLawsuitNames.join(','),
					// 诉讼专业（案由）- 使用逗号分割的字符串
					litigationTypeId: lawsuitIds.join(','),
					litigationTypeName: lawsuitNames.join(','),
					userId: this.userUpdateInfo.userId,
					userName: this.userUpdateInfo.userName
				}
				updateMajor(objs).then(res => {
					this.$message.success("修改成功");
					this.getUserInfoFun();
					// 重置选择状态
					this.selectedLawsuitIds = [];
					this.selectedLawsuitItems = [];
					this.selectedNonLawsuitIds = [];
					this.selectedNonLawsuitItems = [];
					this.showMajor = false;
				})
			},
			// 获取非诉讼专业
			getMajorTreeselect() {
				return majorTreeSelect().then(res => {
					this.majorList = res.data
				})
			},
			/* 获取用户信息 */
			getUserInfoFun() {
				getUserInfo({}).then((res) => {
					this.userInfo = res.user;
					this.userUpdateInfo.userId = res.user.userId;
					this.messageParams.lawyerId = res.user.userId;
					this.userUpdateInfo.userName = res.user.userName;
					
					// 非诉讼专业
					this.userUpdateInfo.majorId = res.user.majorId ? JSON.parse(res.user.majorId) : [];
					let arr = res.user.major ? res.user.major.split(",") : [];
					this.userMajor = arr.join("-");
					this.checkedKeys = res.user.majorId ? JSON.parse(res.user.majorId) : [];
					
					// 诉讼专业（案由）- litigationTypeId 是逗号分割的字符串
					const litigationTypeIdStr = res.user.litigationTypeId || '';
					this.userUpdateInfo.litigationTypeId = litigationTypeIdStr ? litigationTypeIdStr.split(',').map(id => parseInt(id) || id) : [];
					let litigationArr = res.user.litigationTypeName ? res.user.litigationTypeName.split(",") : [];
					this.litigationCheckedKeys = this.userUpdateInfo.litigationTypeId;
					
					console.log("res.user", res.user);
					this.getMessage();
				});
			},
			/* 获取通知消息 */
			getNoticeList(e, type, isLoadMore = false) {
				// 如果是加载更多且已经没有更多数据，直接返回
				if (isLoadMore && this.noMoreMessage) {
					return;
				}
				
				// 设置加载状态
				if (isLoadMore) {
					this.messageLoading = true;
				}
				
				const pageNum = e ? e : this.noticePageNum;
				
				noticeList({
					noticeType: 2,
					pageSize: this.messagePageSize,
					pageNum: pageNum
				}).then((res) => {
					const newRows = res.rows || [];
					
					if (isLoadMore) {
						// 加载更多：追加数据
						this.messageList = [...this.messageList, ...newRows];
					} else {
						// 首次加载或刷新：替换数据
						this.messageList = newRows;
						this.noticePageNum = 1;
						this.noMoreMessage = false;
					}
					
					// 判断是否还有更多数据
					const total = res.total || 0;
					if (this.messageList.length >= total || newRows.length < this.messagePageSize) {
						this.noMoreMessage = true;
					}
					
					this.msgNum = res.msg ? parseInt(res.msg) : 0;
					
					// 播放提示音
					if (this.messageList.length > 0 && type) {
						for (var i = 0; i < this.messageList.length; i++) {
							let item = this.messageList[i];
							if (item.status != 1) {
								this.playMessageAudio();
								break;
							}
						}
					}
				}).finally(() => {
					this.messageLoading = false;
				});
			},
			/* 获取时间 */
			getTime() {
				this.deteInfo.time = this.$funs.getNowTime('hh-mm');
				this.deteInfo.day = this.$funs.getNowTime('mm-dd');
				this.deteInfo.week = this.$funs.getNowTime('week');
			},
			// async logout() {
			// 	this.$router.push(`/login?redirect=${this.$route.fullPath}`)
			// }

			logout() {
				this.$confirm('确定注销并退出系统吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$socketPublic.dispatch('closeWebSocket');
					removeToken();
					location.href = '/login';
					return
				}).catch(() => {});
			},
			/* 修改密码 */
			setPassSubmit() {
				this.$refs['passForm'].validate((valid) => {
					if (valid) {
						updateUserPwd(this.passForm.oldPassword, this.passForm.newPassword).then(response => {
							this.$message.success("修改成功");
							this.showSetPass = false;
							removeToken();
							for (let key in this.passForm) {
								this.passForm[key] = ""
							}
							this.$socketPublic.dispatch('closeWebSocket');
							removeToken();
							location.href = '/login';
						});
					}
				})

			},
			/* 验证确认密码 */
			equalToPassword(e) {
				console.log("equalToPassword", e)
				if (this.passForm.newPassword !== this.passForm.confirmPassword) {
					this.$message.error('两次输入的密码不一致');
					this.passForm.confirmPassword = ""
				}
			},
			/* 修改头像 */
			uploadSuccess(e) {
				console.log("修改头像", e.file);
				this.userInfo.avatar = e.url;
				/** 上传图片 */
				let formData = new FormData();
				formData.append("avatarfile", e.file);
				console.log(formData.get('avatarfile'));
			},
			// 编辑头像
			editCropper() {
				this.userDialog = false;
				this.open = true;
				this.$forceUpdate()
			},
			// 打开弹出层结束时的回调
			modalOpened() {
				this.visible = true;
				if (!this.resizeHandler) {
					this.resizeHandler = debounce(() => {
						this.refresh()
					}, 100)
				}
				window.addEventListener("resize", this.resizeHandler)
			},
			// 刷新组件
			refresh() {
				this.$refs.cropper.refresh();
			},
			// 覆盖默认的上传行为
			requestUpload() {},
			// 向左旋转
			rotateLeft() {
				this.$refs.cropper.rotateLeft();
			},
			// 向右旋转
			rotateRight() {
				this.$refs.cropper.rotateRight();
			},
			// 图片缩放
			changeScale(num) {
				num = num || 1;
				this.$refs.cropper.changeScale(num);
			},
			// 上传预处理
			beforeUpload(file) {
				if (file.type.indexOf("image/") == -1) {
					this.$message.error('文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。');
				} else {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						this.options.img = reader.result;
					};
				}
			},
			// 上传图片
			uploadImg() {
				this.$refs.cropper.getCropBlob(data => {
					let formData = new FormData();
					console.log("修改头像data---", data)
					formData.append("avatarfile", data);
					uploadAvatar(formData).then(response => {
						this.open = false;
						this.options.img = response.imgUrl;
						this.userInfo.avatar = response.imgUrl;
						this.$message.success("修改成功");
						this.visible = false;
					});
				});
			},
			// 实时预览
			realTime(data) {
				this.previews = data;
			},
			// 关闭窗口
			closeDialog() {
				this.options.img = this.$store.getters.avatar
				this.visible = false;
				window.removeEventListener("resize", this.resizeHandler)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.item-view {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 20px;
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
		cursor: pointer;
	}

	.item-icon-view {
		width: 68px;
		height: 68px;
		background: linear-gradient(#6266bf, #112375);
		border-radius: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.msg-icon {
		width: 43px;
		height: 43px;
	}

	.item-data {
		flex: 1;
		display: flex;
		flex-direction: column;
		margin-left: 15px;
	}

	.item-msg-title {
		font-weight: 500;
		font-style: normal;
		font-size: 18px;
		color: #333;
	}

	.item-msg-text {
		font-weight: 400;
		font-style: normal;
		color: rgba(51, 51, 51, 0.5);
		font-size: 13px;
	}

	.navbar {
		width: 100%;
		height: 80px;
		background: #fafafa;

			.home-container {
				height: 100%;
				cursor: pointer;
				padding-left: 30px;
				box-sizing: border-box;
				.home-wrapper {
					background: linear-gradient(to bottom, #0AA4F1, #7883FE);
					width: 46px;
					height: 46px;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					.home-icon {
						width: 30px;
						height: 30px;
					}
				}
				.username {
					font-size: 30px;
					margin-left: 20px;
				}
			}

			.breadcrumb-container {
				float: left;
			}

			.right-menu {
				height: 100%;

				&:focus {
					outline: none;
				}

				.right-menu-item {
					display: inline-block;
					padding: 0 8px;
					height: 100%;
					font-size: 18px;
					color: #5a5e66;
					vertical-align: text-bottom;

					&.hover-effect {
						cursor: pointer;
						transition: background .3s;

						&:hover {
							background: rgba(0, 0, 0, .025)
						}
					}
				}

				.avatar-container {
					margin-right: 30px;

					.avatar-wrapper {
						position: relative;

						.user-avatar {
							cursor: pointer;
							width: 50px;
							height: 50px;
							border-radius: 50%;
						}

						.el-icon-caret-bottom {
							cursor: pointer;
							position: absolute;
							right: -20px;
							top: 25px;
							font-size: 12px;
						}
					}
				}
				
				.time-container {
					display: flex;
					flex-direction: column;
					margin-right: 30px;
					.time-title {
						font-weight: 650;
						font-style: normal;
						font-size: 45px;
					}
				
					.data-title {
						font-weight: 650;
						font-style: normal;
						font-size: 17px;
					}
				}
			}
	}


	.message-dialog {
		position: fixed;
		width: 400px;
		max-height: 500px;
		z-index: 10000;
		background-color: #fff;
		top: 60px;
		right: 60px;
		border-radius: 20px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		border: 2px solid #000;
		.message-container {
			display: flex;
			flex-direction: column;
			height: 100%;
			max-height: 500px;
			
			.message-title {
				background-color: #437acc;
				height: 80px;
				min-height: 80px;
				text-align: center;
				font-size: 20px;
				line-height: 80px;
				font-weight: 800;
				color: #fff;
			}

			.message-scroll-container {
				flex: 1;
				overflow-y: auto;
				max-height: 420px;
				
				&::-webkit-scrollbar {
					width: 6px;
				}
				
				&::-webkit-scrollbar-thumb {
					background-color: #c0c4cc;
					border-radius: 3px;
				}
				
				&::-webkit-scrollbar-track {
					background-color: #f5f5f5;
				}
			}

			.item-icon-view {
				width: 60px;
				height: 60px;
				background-color: #263488;
				border-radius: 10px;
			}
		}
	}
	
	// 加载更多样式
	.loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 15px 0;
		color: #909399;
		font-size: 14px;
		
		i {
			margin-right: 8px;
			font-size: 16px;
		}
	}
	
	// 没有更多数据样式
	.no-more-data {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 15px 0;
		color: #c0c4cc;
		font-size: 13px;
	}
	
	// 空数据样式
	.empty-message {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 60px 0;
		color: #909399;
		
		i {
			font-size: 48px;
			margin-bottom: 15px;
			color: #c0c4cc;
		}
		
		span {
			font-size: 14px;
		}
	}
	
	.message-dialog::-webkit-scrollbar {
	  display: none;
	  width: 0 !important;
	}

	::v-deep el-dropdown-menu:hover,
	::v-deep .el-dropdown-menu__item:hover {
		background-color: transparent;
	}
	
	// 补充解答相关样式
	.supplement-info {
		background-color: #f5f7fa;
		padding: 15px;
		border-radius: 8px;
		border-left: 4px solid #409eff;
		
		p {
			margin: 8px 0;
			font-size: 14px;
			color: #606266;
			line-height: 1.6;
			
			strong {
				color: #303133;
				margin-right: 8px;
			}
		}
	}
	
	// 补充解答列表样式
	.supplement-list {
		max-height: 350px;
		overflow-y: auto;
		
		.supplement-item {
			padding: 15px;
			margin-bottom: 12px;
			background-color: #fafafa;
			border-radius: 8px;
			border: 1px solid #ebeef5;
			
			&:last-child {
				margin-bottom: 0;
			}
			
			.supplement-content {
				font-size: 14px;
				color: #303133;
				line-height: 1.8;
				margin-bottom: 10px;
				word-break: break-all;
			}
			
			.supplement-meta {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 12px;
				color: #909399;
				
				.supplement-author {
					color: #606266;
				}
				
				.supplement-time {
					color: #909399;
				}
			}
		}
	}
	
	.empty-supplement {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 40px 0;
		color: #909399;
		
		i {
			font-size: 40px;
			margin-bottom: 12px;
			color: #c0c4cc;
		}
		
		span {
			font-size: 14px;
		}
	}
	
	.fontColor-index {
		color: #409eff;
		
		&:hover {
			color: #66b1ff;
		}
	}
	
	.mb-20 {
		margin-bottom: 20px;
	}
	
	.ml-10 {
		margin-left: 10px;
	}
	
	// 修改专业弹窗样式
	.major-dialog {
		::v-deep .el-dialog__body {
			padding: 10px 20px 20px;
		}
	}
	
	// Tab切换样式
	.major-tabs {
		display: flex;
		justify-content: center;
		margin-bottom: 20px;
		
		::v-deep .el-radio-group {
			.el-radio-button__inner {
				padding: 12px 30px;
				font-size: 16px;
				font-weight: 500;
			}
			
			.el-radio-button__orig-radio:checked + .el-radio-button__inner {
				background-color: #409eff;
				border-color: #409eff;
				color: #fff;
			}
		}
	}
	
	// 专业内容区域（新版）
	.major-content-new {
		min-height: 420px;
		
		.tree-select-container {
			border: 1px solid #dcdfe6;
			border-radius: 4px;
			overflow: hidden;
			
			.tree-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 12px 15px;
				background-color: #f5f7fa;
				border-bottom: 1px solid #dcdfe6;
				
				.tree-title {
					font-size: 14px;
					font-weight: 500;
					color: #303133;
				}
				
				.tree-filter-input {
					width: 200px;
				}
			}
			
			.tree-wrapper {
				max-height: 280px;
				overflow-y: auto;
				padding: 10px;
				
				&::-webkit-scrollbar {
					width: 6px;
				}
				
				&::-webkit-scrollbar-thumb {
					background-color: #c0c4cc;
					border-radius: 3px;
				}
				
				&::-webkit-scrollbar-track {
					background-color: #f5f5f5;
				}
			}
			
			.major-tree {
				background: transparent;
				
				::v-deep .el-tree-node__content {
					height: 32px;
					
					&:hover {
						background-color: #f0f7ff;
					}
				}
				
				::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
					background-color: #409eff;
					border-color: #409eff;
				}
			}
		}
		
		.selected-tags-container {
			margin-top: 15px;
			padding: 15px;
			background-color: #fafafa;
			border-radius: 4px;
			border: 1px solid #ebeef5;
			
			.selected-tags-header {
				display: flex;
				align-items: center;
				margin-bottom: 10px;
				
				.selected-title {
					font-size: 14px;
					font-weight: 500;
					color: #303133;
				}
				
				.selected-count {
					font-size: 12px;
					color: #909399;
					margin-left: 8px;
				}
				
				.clear-all-btn {
					margin-left: auto;
					color: #f56c6c;
					padding: 0;
					
					&:hover {
						color: #f78989;
					}
				}
			}
			
			.selected-tags-wrapper {
				display: flex;
				flex-wrap: wrap;
				gap: 8px;
				max-height: 120px;
				overflow-y: auto;
				
				&::-webkit-scrollbar {
					width: 4px;
				}
				
				&::-webkit-scrollbar-thumb {
					background-color: #c0c4cc;
					border-radius: 2px;
				}
			}
			
			.selected-tag {
				max-width: 200px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				
				::v-deep .el-tag__close {
					color: #909399;
					
					&:hover {
						background-color: #909399;
						color: #fff;
					}
				}
			}
			
			.empty-selected {
				text-align: center;
				padding: 20px 0;
				color: #909399;
				font-size: 13px;
			}
		}
	}
</style>